$(window).on("message", function(event) {
    if (event.data == "event=ended") {
    	var published_date = $("#digiteka-player").data("published");
    	var videovertical = $("#digiteka-player").data("videovertical");
    	get_next_video(published_date, videovertical); 
    }
});

